import { Button, Flex, Stack, Text } from '@chakra-ui/react';
import type { DashboardTodoSourceKey } from '@fluenceur/types';
import { TodoLineIcon } from './TodoLineIcon';

interface TodoFailedRowProps {
  lineKey: DashboardTodoSourceKey;
  label: string;
  message: string;
  retryLabel: string;
  onRetry: () => void;
}

/** A subject whose figures could not be read: named, with a way to ask again. */
export const TodoFailedRow = ({
  lineKey,
  label,
  message,
  retryLabel,
  onRetry,
}: TodoFailedRowProps) => (
  <Flex
    align="center"
    gap="12px"
    px="12px"
    py="11px"
    borderTopWidth="1px"
    borderTopColor="border.subtle"
  >
    <TodoLineIcon lineKey={lineKey} />
    <Stack gap="2px" flex="1" minW="0">
      <Text fontSize="14px" fontWeight="500" color="ink" lineClamp={1}>
        {label}
      </Text>
      <Text fontSize="12.5px" color="inkMuted">
        {message}
      </Text>
    </Stack>
    <Button size="xs" variant="outline" onClick={onRetry}>
      {retryLabel}
    </Button>
  </Flex>
);
